import { render, staticRenderFns } from "./toolbar-button.vue?vue&type=template&id=65724032&"
import script from "./toolbar-button.vue?vue&type=script&lang=js&"
export * from "./toolbar-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports